/**
 * @flow
 * @relayHash ed37992c98a8733ec20707080a2bcefa
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CopyWidgetsMutationVariables = {|
  input: {
    destinationReportIds?: ?$ReadOnlyArray<?string>;
    widgetIds?: ?$ReadOnlyArray<?string>;
    clientMutationId?: ?string;
  };
|};

export type CopyWidgetsMutationResponse = {|
  +copyWidgets: ?{|
    +reports: ?$ReadOnlyArray<?{|
      +id: string;
    |}>;
  |};
|};
*/


/*
mutation CopyWidgetsMutation(
  $input: CopyWidgetsInput!
) {
  copyWidgets(input: $input) {
    reports {
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "CopyWidgetsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CopyWidgetsMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CopyWidgetsInput!"
          }
        ],
        "concreteType": "CopyWidgetsPayload",
        "name": "copyWidgets",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "name": "reports",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CopyWidgetsMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "CopyWidgetsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "CopyWidgetsMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CopyWidgetsInput!"
          }
        ],
        "concreteType": "CopyWidgetsPayload",
        "name": "copyWidgets",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "name": "reports",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation CopyWidgetsMutation(\n  $input: CopyWidgetsInput!\n) {\n  copyWidgets(input: $input) {\n    reports {\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/CopyWidgetsMutation.graphql.js